var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCockpit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#3A3A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6636 10.6406H14.1749C14.1295 10.3187 14.0367 10.0327 13.8965 9.78267C13.7564 9.52888 13.5764 9.31297 13.3567 9.13494C13.1371 8.95691 12.8833 8.82055 12.5954 8.72585C12.3113 8.63115 12.0026 8.58381 11.6692 8.58381C11.067 8.58381 10.5424 8.73343 10.0954 9.03267C9.64841 9.32812 9.30182 9.75994 9.05561 10.3281C8.8094 10.8925 8.68629 11.5781 8.68629 12.3849C8.68629 13.2145 8.8094 13.9115 9.05561 14.4759C9.30561 15.0402 9.6541 15.4664 10.1011 15.7543C10.548 16.0421 11.0651 16.1861 11.6522 16.1861C11.9817 16.1861 12.2867 16.1425 12.567 16.0554C12.8511 15.9683 13.103 15.8414 13.3227 15.6747C13.5424 15.5043 13.7242 15.2978 13.8681 15.0554C14.0158 14.813 14.1181 14.5365 14.1749 14.2259L16.6636 14.2372C16.5992 14.7713 16.4382 15.2865 16.1806 15.7827C15.9268 16.2751 15.584 16.7164 15.1522 17.1065C14.7242 17.4929 14.2128 17.7997 13.6181 18.027C13.0272 18.2505 12.3586 18.3622 11.6124 18.3622C10.5745 18.3622 9.64652 18.1274 8.82834 17.6577C8.01394 17.188 7.37 16.508 6.89652 15.6179C6.42682 14.7277 6.19197 13.6501 6.19197 12.3849C6.19197 11.116 6.43061 10.0365 6.90788 9.14631C7.38516 8.25615 8.03288 7.57812 8.85106 7.11221C9.66925 6.64252 10.5897 6.40767 11.6124 6.40767C12.2867 6.40767 12.9117 6.50237 13.4874 6.69176C14.067 6.88115 14.5802 7.15767 15.0272 7.5213C15.4742 7.88115 15.8378 8.32244 16.1181 8.84517C16.4022 9.3679 16.584 9.96638 16.6636 10.6406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCockpit);
export default __webpack_public_path__ + "static/media/Cockpit.b12be5121e4a8eb43bf585055c9299e1.svg";
export { ForwardRef as ReactComponent };